import React, { useState } from "react";
import styled from "styled-components";
import { AiOutlineCheckCircle } from "react-icons/ai"; 
import dropDown from '../Assets/template/overview.png';
import bgImage from '../Assets/template/vmo.jpg';

const HelpGuest = () => {
  const [selectedSection, setSelectedSection] = useState("Manage Irrigation");

  const steps = {
    "Manage Irrigation": [
      "Navigate to the irrigation management section in the dashboard.",
      "Select the type of irrigation system you want to manage (e.g., Drip, Sprinkler).",
      "Monitor the water usage and efficiency of the system through the available charts.",
      "Adjust the water flow rate according to the crops' needs.",
      "Use the 'Schedule' option to automate watering times based on your farm's needs.",
      "For any issues with the system, contact support through the 'Help' section."
    ],
    "Update Irrigation Preferences": [
      "Go to the 'Settings' section under your profile.",
      "Select 'Irrigation Preferences' to customize your irrigation settings.",
      "Choose your preferred irrigation schedule based on weather patterns and crop types.",
      "Adjust the settings for water flow, pressure, and duration of watering cycles.",
      "Save the settings to apply them to your system."
    ],
    "Irrigation Troubleshooting": [
      "If you encounter issues, navigate to the 'Troubleshooting' section.",
      "Check the system status to see if any parts of the system are malfunctioning.",
      "For water pressure problems, verify that the valves and pumps are functioning properly.",
      "Consult the guide to learn how to clean or replace clogged filters and nozzles.",
      "If the problem persists, contact customer support for further assistance."
    ]
  };

  return (
    <Container>
      {/* Sidebar */}
      <Sidebar>
        <SidebarTitle>Help Menu</SidebarTitle>
        {Object.keys(steps).map((item) => (
          <SidebarButton
            key={item}
            isActive={selectedSection === item}
            onClick={() => setSelectedSection(item)}
          >
            {item}
          </SidebarButton>
        ))}
      </Sidebar>

      {/* Content Area */}
      <Content>
        <h2>{selectedSection} - Steps</h2>
        {steps[selectedSection].map((step, index) => (
          <Step key={index}>
            <AiOutlineCheckCircle size={20} color="green" />
            <StepText>{step}</StepText>
          </Step>
        ))}
      </Content>
    </Container>
  );
};

export default HelpGuest;

// Styled Components
const Container = styled.div`
  display: flex;
  height: 100vh;
  background-color: rgb(249, 251, 252);
`;

const Sidebar = styled.div`
  width: 250px;
  background-image: url(${bgImage});
  background: rgba(8, 161, 13, 0.4);
  padding: 20px;
`;

const SidebarTitle = styled.h2`
  color: white;
  text-align: center;
  margin-bottom: 20px;
`;

const SidebarButton = styled.button`
  display: block;
  width: 100%;
  padding: 10px;
  color: white;
  border: none;
  background-image: linear-gradient(rgba(78, 151, 78, 0.5), rgba(0, 0, 0, 0.5)), url(${dropDown});
  text-align: left;
  cursor: pointer;
  font-size: 16px;
  transition: background 0.3s;

  &:hover {
    background-color: #1f2b38;
  }
`;

const Content = styled.div`
  flex: 1;
  padding: 20px;
`;

const Step = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;

const StepText = styled.p`
  font-size: 16px;
  margin-left: 10px;
`;
